import {z} from '@hono/zod-openapi';

import {composeMessageFactSchema} from './ComposeMessageFactSchema';
import {composeMessageLocaleSchema} from './ComposeMessageLocaleSchema';
import {composeMessageUnavailableFactSchema} from './ComposeMessageUnavailableFactSchema';

export const composeMessageResponseSchema = z
  .object({
    body: z.string().min(1).max(24000),
    subject: z.string().max(500).optional(),
    bodyFormat: z.enum(['HTML', 'PLAIN_TEXT']),
    usedContext: z.array(composeMessageFactSchema).max(64),
    unavailableContext: z.array(composeMessageUnavailableFactSchema).max(64),
    locale: composeMessageLocaleSchema.optional(),
    languageSource: z.enum(['customer', 'tenant']).optional(),
  })
  .strict()
  .openapi('ComposeMessageResponse');

export type ComposeMessageResponse = z.infer<typeof composeMessageResponseSchema>;
